export default __webpack_public_path__ + "static/media/closeIcon.b9e57656.svg";